
        var result = require("!!../../../../node_modules/css-loader/index.js!./stock.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/stock/stock.component.css
// module id = 632
// module chunks = 0